export default {
  apiDomain: 'https://api.fakeflighttickets.com',
  apiDomain2: 'https://heroku.fakeflighttickets.com',
  stripePK: 'pk_live_51A6ETAGv7zk6xVtkuSm6kYOcQbKzFsNYMEC1Ovxu15dGfof9uaz6FaJpzNWh43a12f67qGQHlvtZhDHtkvSAAtEm0026RAn8KB',
  stripeSKU: 'sku_Ek7o3zWmgf5QSP',
  coinbaseCommerceCheckoutId: '6fd024ba-6621-4f2e-a4ed-c98cb235c51b',
  coinbaseCommerce: {
    5: '6fd024ba-6621-4f2e-a4ed-c98cb235c51b',
    10: '4bd464d3-dcd2-4de2-ad1d-62ca7775dcc4',
    15: 'e7eca987-1226-47be-a8c4-bbf5c24ab508',
    20: 'baf17485-0472-4469-a671-774b1537c797',
    25: 'f63f0a9b-4bfa-4183-8cef-33ba9e3607e7',
    30: 'b7ba2d8b-1250-4851-b21d-04d2c6a245c8',
    35: 'f6bd7fe7-a325-43c2-80e1-11eae8f7da7e',
  },
  payPalClientId:
    'AdXCg0-s9V1S3nHuGs0iwLRgVRSpTejSV9SdLFli7TUkzW2_3T8bJa-ZFkm0eOXbZMJ8FxfoVKIw6wDk',
  payPalEnv: 'production',
  freshchat: {
    token: 'b5b8bc0e-c509-47d7-b2fa-acd90ad39581',
    host: 'https://wchat.freshchat.com',
  },
}



// WEBPACK FOOTER //
// ./src/config/prod.js